import type HttpClient from "../../tastyworks/http"
import type { ItemsResponse } from "../../tastyworks/response"
import {
  SYMBOL_SEARCH_ITEM_DESER,
  SymbolSearchItem,
} from "../../tastyworks/symbol-search-item"

export default class SymbolSearchService {
  constructor(private readonly symbolsHttpClient: HttpClient) {}

  readonly search = async (
    path: string,
    query: string
  ): Promise<ItemsResponse<SymbolSearchItem>> =>
    this.symbolsHttpClient.indexSimple(
      SYMBOL_SEARCH_ITEM_DESER.toParser(SymbolSearchItem),
      `${path}/${encodeURIComponent(query)}`
    )

  readonly lookup = async (
    symbols: readonly string[]
  ): Promise<ItemsResponse<SymbolSearchItem>> =>
    this.symbolsHttpClient.indexSimple(
      SYMBOL_SEARCH_ITEM_DESER.toParser(SymbolSearchItem),
      "lookup",
      { symbols: symbols.join(",") }
    )
}
